export class PushNotifParameters {
    PushEnabled: boolean;
    HKTaskStateChanges_New: string;
    HKTaskStateChanges_AssignedToChanged: string;
    HKTaskStateChanges_SupervisorChanged: string;
    HKTaskStateChanges_Ended: string;
    HKTaskStateChanges_Inspected: string;
    MTaskStateChanges_New: string;
    MTaskStateChanges_AssignedToChanged: string;
    MTaskStateChanges_SupervisorChanged: string;
    MTaskStateChanges_Ended: string;
    MTaskStateChanges_Inspected: string;
    RoomStateChanges_Dirty: string;
    RoomStateChanges_Clean: string;
    RoomStateChanges_Inspected: string;
    RoomStateChanges_OOO: string;
    RoomReservationChanges_Arrived: string;
    RoomReservationChanges_CheckedOut: string;
    RoomReservationChanges_LateCheckout: string;
}
   
 